import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationAttachmentEntity } from '../../../domain/entities/investigation-attachment.entity';

export interface UploadInvestigationAttachmentCommand { investigationId: string; file: File; }
export interface UploadInvestigationAttachmentResult { attachment: InvestigationAttachmentEntity; }

@Injectable({ providedIn: 'root' })
export class UploadInvestigationAttachmentUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: UploadInvestigationAttachmentCommand, onProgress?: (progress: number) => void): Observable<UploadInvestigationAttachmentResult> {
    return this._repository.uploadAttachment(command.investigationId, command.file, onProgress).pipe(
      map((attachment) => ({ attachment })),
    );
  }
}
